import script from "./NumberInsertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberInsertModal.vue?vue&type=script&setup=true&lang=js"

import "./NumberInsertModal.vue?vue&type=style&index=0&id=aec3619c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aec3619c"]])

export default __exports__